import MuiLanIcon from '@mui/icons-material/Lan';
import MuiBluetoothIcon from '@mui/icons-material/Bluetooth';
import MuiCameraAltIcon from '@mui/icons-material/CameraAlt';
import MuiLocationOnIcon from '@mui/icons-material/LocationOn';
import MuiContentPasteIcon from '@mui/icons-material/ContentPaste';

import { DevicePermission } from './types';

export const REQUIRED_PERMISSIONS: DevicePermission[] = [
  {
    id: 'bluetooth',
    name: 'Bluetooth',
    description:
      'Required to connect to card readers and receipt printers. This enables contactless payments and receipt printing.',
    icon: MuiBluetoothIcon,
    status: 'prompt',
    required: true,
  },
  {
    id: 'location',
    name: 'Location',
    description:
      'Required by payment processors for fraud prevention and transaction verification. Your location is never stored or shared.',
    icon: MuiLocationOnIcon,
    status: 'prompt',
    required: true,
  },
  {
    id: 'camera',
    name: 'Camera',
    description:
      'Used for scanning product barcodes during checkout and inventory management. The camera is only accessed when you initiate a scan.',
    icon: MuiCameraAltIcon,
    status: 'prompt',
    required: true,
  },
  {
    id: 'localNetwork',
    name: 'Local Network',
    description:
      'Required to discover and connect to receipt printers, card readers (PAX Terminal), and other POS devices on your local network.',
    icon: MuiLanIcon,
    status: 'prompt',
    required: true,
    platforms: ['ios'], // iOS only - Android has no runtime permission for local network
  },
  {
    id: 'clipboard',
    name: 'Clipboard',
    description:
      'Used to paste payment amounts, product codes, and customer information for faster checkout. Your clipboard data is only accessed when you explicitly paste.',
    icon: MuiContentPasteIcon,
    status: 'prompt',
    required: true,
    platforms: ['ios'], // iOS 16+ shows permission prompt; Android has no runtime permission
  },
];

// Permission descriptions for iOS Info.plist (for reference)
export const IOS_PERMISSION_DESCRIPTIONS = {
  bluetooth: 'This app uses Bluetooth to connect to readers and printers.',
  location: 'Location access is required to accept payments.',
  camera: 'To take pictures of barcodes for scanning.',
  localNetwork:
    'PointCraft needs local network access to discover and connect to receipt printers, card readers, and other POS devices on your network.',
  // Note: clipboard has no Info.plist key - permission prompt is automatic on iOS 16+
};

// Android permissions mapping
export const ANDROID_PERMISSIONS = {
  bluetooth: [
    'android.permission.BLUETOOTH',
    'android.permission.BLUETOOTH_ADMIN',
    'android.permission.BLUETOOTH_CONNECT',
    'android.permission.BLUETOOTH_SCAN',
  ],
  location: [
    'android.permission.ACCESS_FINE_LOCATION',
    'android.permission.ACCESS_COARSE_LOCATION',
  ],
  camera: ['android.permission.CAMERA'],
};
